import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface GlobalState {
  opened: boolean;
  folded: boolean;
  mobileOpened: boolean;
  dialogs: string[];
  dialogData:any;
}

// El menú lateral (solo admins) parte abierto con los nombres en pantallas anchas; en notebooks parte plegado
// para no apretar la barra de arriba. Se puede abrir o plegar con su botón.
const WIDE_SCREEN = typeof window !== 'undefined' && window.innerWidth >= 1600;

const initialState: GlobalState = {
  opened: WIDE_SCREEN,
  folded: true,
  mobileOpened: false,
  dialogs: [],
  dialogData: {},
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    toggleNarvarAction: (state) => {
      state.opened = !state.opened;
    },
    openNarvarAction: (state) => {
      state.opened = true;
    },
    closeNarvarAction: (state) => {
      state.opened = false;
    },
    foldNarvarAction: (state) => {
      state.folded = true;
    },
    unfoldNarvarAction: (state) => {
      state.folded = false;
    },
    toggleMobileNarvarAction: (state) => {
      state.mobileOpened = !state.mobileOpened;
    },
    openMobileNarvarAction: (state) => {
      state.mobileOpened = true;
    },
    closeMobileNarvarAction: (state) => {
      state.mobileOpened = false;
    },
    openDialogAction: (
      state,
      action: PayloadAction<{ dialog: string; data?: any }>
    ) => {
      state.dialogs = [...state.dialogs, action.payload.dialog];
      state.dialogData[action.payload.dialog] = action.payload.data;
    },
    closeDialogAction: (state, action: PayloadAction<string>) => {
      state.dialogs = state.dialogs.filter((dialog) => dialog !== action.payload);
    },
    closeAllDialogAction: (state) => {
      state.dialogs = [];
    },
    globalClearAction: (state) => {
      state.opened = WIDE_SCREEN;
      state.folded = true;
      state.mobileOpened = false;
      state.dialogs = [];
    },
  },
});

export const {
  toggleNarvarAction,
  openNarvarAction,
  closeNarvarAction,
  foldNarvarAction,
  unfoldNarvarAction,
  toggleMobileNarvarAction,
  openMobileNarvarAction,
  closeMobileNarvarAction,
  openDialogAction,
  closeDialogAction,
  closeAllDialogAction,
  globalClearAction,
} = globalSlice.actions;

export default globalSlice.reducer;
